export const ERC20 = 'erc20';
export const ERC721 = 'ERC721';
export const ERC1155 = 'ERC1155';

export const SHUFFLE_LOGO = 'https://static-hupay.s3.ap-northeast-2.amazonaws.com/shuffle/shuffle_140140.png';
